var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "tabs-m hidden-pad-up" }, [
      _c(
        "div",
        {
          staticClass: "tabs-m__item privacy",
          class: { activeTabM: _vm.activeTab == "privacy" },
          on: {
            click: function($event) {
              return _vm.changeTab("privacy")
            }
          }
        },
        [_vm._v("\n        隐私权政策\n      ")]
      ),
      _c(
        "div",
        {
          staticClass: "tabs-m__item service",
          class: { activeTabM: _vm.activeTab == "service" },
          on: {
            click: function($event) {
              return _vm.changeTab("service")
            }
          }
        },
        [_vm._v("\n        服务条款\n      ")]
      )
    ]),
    _c("div", { staticClass: "block custom-row custom-container" }, [
      _c("div", { staticClass: "tabs hidden-pad-down" }, [
        _c(
          "div",
          {
            staticClass: "tabs__item privacy",
            class: { activeTab: _vm.activeTab == "privacy" },
            on: {
              click: function($event) {
                return _vm.changeTab("privacy")
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "80",
                  height: "80",
                  fill: "none",
                  viewBox: "0 0 80 80"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    d:
                      "M17.917 16.667l2.588-2.022L40 19.52l19.495-4.873 2.588 2.02v2.917h4.584l2.083 2.084v35l-1.52 2.005-26.666 7.5h-1.128l-26.667-7.5-1.519-2.005v-35l2.083-2.084h4.584v-2.916zm0 7.083h-2.5v31.338l22.5 6.328v-4.02L19.417 52l-1.5-2V23.75zm24.166 33.646L60.583 52l1.5-2V23.75h2.5v31.338l-22.5 6.328v-4.02zm0-4.34V23.293l15.834-3.958v29.102l-15.834 4.619zm-4.166-29.763v29.763l-15.834-4.618V19.334l15.834 3.958zm-3.321 5.824l-10-2.5.808-3.234 10 2.5-.808 3.234zm-10 6.666l10 2.5.808-3.233-10-2.5-.808 3.233zm10 11.667l-10-2.5.808-3.234 10 2.5-.808 3.234zm20.808-20.833l-10 2.5-.808-3.234 10-2.5.808 3.234zm-10 11.666l10-2.5-.808-3.233-10 2.5.808 3.233zm10 6.667l-10 2.5-.808-3.234 10-2.5.808 3.234z",
                    "clip-rule": "evenodd"
                  }
                })
              ]
            ),
            _c("span", [_vm._v("隐私权政策")])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "tabs__item service",
            class: { activeTab: _vm.activeTab == "service" },
            on: {
              click: function($event) {
                return _vm.changeTab("service")
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "80",
                  height: "80",
                  fill: "none",
                  viewBox: "0 0 80 80"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    d:
                      "M22.5 17.5h35v45h-35v-45zm-4.166 49.167V13.333h43.333v53.334H18.333zm10-41.667H35v-3.333h-6.666V25zm23.333 8.333H28.333V30h23.334v3.333zm-23.334 8.334h23.334v-3.334H28.333v3.334zM51.668 50H28.333v-3.333h23.334V50zm-15 8.333h15V55h-15v3.333z",
                    "clip-rule": "evenodd"
                  }
                })
              ]
            ),
            _c("span", [_vm._v("服务条款")])
          ]
        )
      ]),
      _c("div", { staticClass: "content-box" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab == "privacy",
                expression: "activeTab == 'privacy'"
              }
            ],
            staticClass: "content"
          },
          [
            _vm._m(1),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            © ASTRORG 星学会展示网站。本网站仅供业务开发、合作提案与产品展示使用。网站内容包含客制化星盘服务、产品概念、流量变现模型与合作案例示意；相关数据已依保密原则进行汇整或比例化处理，仅供潜在合作伙伴评估参考。实际服务内容、合作条件、授权方式与商业模式，将以双方正式合同为准。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("一、隐私权保护政策的适用范围")
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            隐私权保护政策内容，包括本网站如何处理在您使用网站服务时收集到的个人识别资料。当您经由本网站所提供的连结，点选进入其他网站时，您必须参考该连结网站中的隐私权保护政策。隐私权保护政策不适用于本网站以外的相关连结网站，也不适用于非本网站所委托或参与管理的人员。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("二、个人资料的搜集、处理及利用方式")
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            我们将视业务或活动性质请您提供必要的个人资料，以便完成交易与相关服务。 \n          "
              )
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            请确认您所提供的个人资料真实准确，本公司不会承担您资料中所提供不准确或不完整资讯所造成之损害或错误，此将须自行负责。\n          "
              )
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            如果您拒绝提供个人资料，可能无法充分利用本网站某些服务。 \n          "
              )
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            请妥善保管您的会员帐号及密码，不要将上述资料提供给任何人或允许任何人以您的个人资料申请或使用帐号、密码，本公司不会承担任何不当使用密码之责任。  \n          "
              )
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            “个人资料”包含您的姓名、住址、电话、生日、电子邮件信箱等，我们非常重视保护个人资料的隐私，您的个人资料不会被出售或转送给其他人或机构，除非法律上需要。\n          "
              )
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            为提供精确的服务，我们会将收集的问卷调查内容进行统计与分析，分析结果之统计数据或说明文字呈现，除供内部研究外，我们会视需要公布统计数据及说明文字，但不涉及特定个人之资料。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("三、资料之保护")
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            本网站主机均设有防火墙、防毒系统等相关的各项资讯安全设备及必要的安全防护措施，加以保护网站及您的个人资料采用严格的保护措施，只由经过授权的人员才能接触您的个人资料，相关处理人员皆签有保密合约，如有违反保密义务者，将会受到相关的法律处分。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("四、与第三人共用个人资料之政策")
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            本网站绝不会提供、交换、出租或出售任何您的个人资料给其他个人、团体、私人企业或公务机关，但有法律依据或合约义务者，不在此限。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("五、隐私权保护政策之修正")
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            本网站隐私权保护政策将因应需求随时进行修正，修正后的条款将刊登于网站上。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("六、您的权利与选择")
            ]),
            _vm._m(2),
            _vm._m(3),
            _vm._m(4),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("七、准据法及管辖法院")
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            因您使用本网站与行动应用程式所造成之争议，您同意均以中华民国法律为准据法。除法律另有强制规定者应依其规定外，并应以台湾台北地方法院为第一审管辖法院。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("八、Facebook 资料删除指示")
            ]),
            _vm._m(5),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("Facebook Data Deletion Instructions")
            ]),
            _vm._m(6),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("九、更新/删除您的个人资讯")
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "若您已注册并希望从系统中删除您提供给我们的任何注册资讯，请透过分页底部的「联络我们」连结与我们联系。根据您的需求，我们将尽力于30天内自活动数据库中删除您的注册资讯，并在可行的情况下从我们的备份媒体中删除您的注册资讯。\n请注意，永久删除您的注册资讯，您的所有个人资料亦从资料库中清除。这道流程完成后，您再也无法使用您的任一项服务，您的使用者帐号与所有资料均将永久移除，将无法恢复您的帐号，或于日后撷取您的个人资料。若您于日后联络本服务支援管道，系统将无法辨认您的帐号与找回已删除的帐号。"
              )
            ])
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab == "service",
                expression: "activeTab == 'service'"
              }
            ],
            staticClass: "content"
          },
          [
            _vm._m(7),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            © ASTRORG 星学会展示网站。本网站仅供业务开发、合作提案与产品展示使用。网站内容包含客制化星盘服务、产品概念、流量变现模型与合作案例示意；相关数据已依保密原则进行汇整或比例化处理，仅供潜在合作伙伴评估参考。实际服务内容、合作条件、授权方式与商业模式，将以双方正式合同为准。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("一、会员服务条款")
            ]),
            _vm._m(8),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("二、隐私权保护")
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            尊重并依据本网站「隐私权保护声明」保护您的隐私(请参阅「隐私权保护声明」条款)。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("三、会员")
            ]),
            _vm._m(9),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("四、使用行为")
            ]),
            _vm._m(10),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("五、本网站权限")
            ]),
            _vm._m(11),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("六、修改权")
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            本公司有权暂时或永久修改或中止提供本服务给您，您不得因此要求任何赔偿。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("七、智慧财产权的保护")
            ]),
            _c("p", { staticClass: "content_p" }, [
              _vm._v(
                "\n            本网站所使用之软体或程式与网站上之所有内容，均由本网站或其他权利人依法享有智慧财产权。未经本网站或其他权利人之事前书面同意，请勿擅自使用、修改、重制、公开播送或发表、散布、改作、发行、进行还原工程、解编或反向组译。倘您欲引用或转载上开内容，请依法取得本网站或其他权利人之事前书面同意，事后并应以明显图字标注资料之来源出处；如有违法情事，应负赔偿责任。\n          "
              )
            ]),
            _c("div", { staticClass: "content_subtitle" }, [
              _vm._v("八、准据法与管辖法院")
            ]),
            _vm._m(12)
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header custom-container" }, [
      _c("div", { staticClass: "header__title" }, [_vm._v("隐私及服务条款")]),
      _c("div", { staticClass: "header__line hidden-pad-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_title" }, [
      _vm._v("\n            [\n            "),
      _c("span", { staticClass: "title-space" }, [_vm._v("网站说明")]),
      _vm._v("]\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticClass: "content_table" }, [
      _c("tr", [
        _c("th", [
          _vm._v("您的权利\n                "),
          _c("br"),
          _vm._v("\n                Your Rights\n              ")
        ]),
        _c("th", [
          _vm._v("意指？\n                "),
          _c("br"),
          _vm._v("What do your rights entail? \n              ")
        ])
      ]),
      _c("tr", [
        _c("td", [
          _vm._v("被告知之权利"),
          _c("br"),
          _c("br"),
          _c("span", [_vm._v("Rights to be Informed")])
        ]),
        _c("td", [
          _vm._v(
            "\n                您有权就我们使用您个人资料之方式，以及您的权利，获取清晰、透明且易于理解的资讯。这正是我们于本政策向您提供该等资讯之原因。\n                "
          ),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v(
              "You have the right to obtain clear, transparent, and easily understandable information about how we use your personal data and your rights. This is precisely why we provide such information to you in this policy. "
            )
          ])
        ])
      ]),
      _c("tr", [
        _c("td", [
          _vm._v("请求查询、阅览、制给复制本之权利\n                "),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v("Right to Request Access, Inspection, and Copies ")
          ])
        ]),
        _c("td", [
          _vm._v(
            "\n                您有权要求查询、阅览由我们持有而与您有关之个人资料，并要求制给复制本（可能需符合一定条件）。"
          ),
          _c("br"),
          _vm._v(
            "\n\n                我们可能会视提供该等资料的行政成本而酌收合理费用。  "
          ),
          _c("br"),
          _vm._v(
            "\n\n                如相关请求明显缺乏依据、过量或反复的要求可能不会获得回复。\n                "
          ),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v(
              "\n                  You have the right to request access and inspection of personal data held by us that relates to you, as well as to request copies to be made (subject to certain conditions). We may charge a reasonable fee based on the administrative costs associated with providing such data. \n\nRequests that are evidently unfounded, excessive, or repetitive may not receive a response. \n                "
            )
          ])
        ])
      ]),
      _c("tr", [
        _c("td", [
          _vm._v("请求补充或更正之权利\n                "),
          _c("br"),
          _c("br"),
          _c("span", [_vm._v("Right to Request Supplement or Correction")])
        ]),
        _c("td", [
          _vm._v(
            "\n                如您的个人资料有误或过时及(或)出现缺漏，您有权要求更正及(或)补充。\n                "
          ),
          _c("br"),
          _c("br"),
          _vm._v(
            "\n\n                除您自行输入资料有误或购买后调整之商品不在此限，其成立之订单仍存在效力。\n\n                "
          ),
          _c("br"),
          _c("span", [
            _vm._v(
              "If your personal data is inaccurate, outdated, and/or incomplete, you have the right to request correction and/or supplementation. Except for errors in data input by yourself or adjustments to purchased items after the fact, the orders established remain valid. \n              "
            )
          ])
        ])
      ]),
      _c("tr", [
        _c("td", [
          _vm._v("请求删除／被遗忘之权利\n                "),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v("Right to Request Deletion/Right to Be Forgotten")
          ])
        ]),
        _c("td", [
          _vm._v(
            "\n                在部份情形，您有权要求我们销毁或删除您的个人资料。请注意，这并非绝对的权利，因我们可能必须依法规要求或基于其他合法里由必须保存您的个人资料。\n                "
          ),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v(
              "In certain circumstances, you have the right to request us to destroy or delete your personal data. Please note that this is not an absolute right, as we may be required by law or other legitimate reasons to retain your personal data. \n              "
            )
          ])
        ])
      ]),
      _c("tr", [
        _c("td", [
          _vm._v("拒绝直接行销（包括个人剖析）之权利\n                "),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v(
              "\n                  Right to Refuse Direct Marketing (including Profiling) \n                "
            )
          ])
        ]),
        _c("td", [
          _vm._v(
            "您可随时取消订阅我们的行销讯息或要求从相关清单退出。\n                "
          ),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v(
              "\n                  You have the right to unsubscribe from our marketing messages at any time or request to be removed from relevant lists. \n                "
            )
          ])
        ])
      ]),
      _c("tr", [
        _c("td", [
          _vm._v(
            "基于同意所进行之资料处理，随时撤回其同意之权利\n                "
          ),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v(
              "Right to Withdraw Consent for Data Processing Based on Consent "
            )
          ])
        ]),
        _c("td", [
          _vm._v(
            "\n                如我们处理您的个人资料系基于您的同意，您可以随时撤回您的同意。撤回同意不会影响在撤回前已经依照您的同意所进行之处理之合法性。\n                "
          ),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v(
              "\n                  If we process your personal data based on your consent, you have the right to withdraw your consent at any time. Withdrawal of consent does not affect the lawfulness of processing based on consent before its withdrawal. \n                "
            )
          ])
        ])
      ]),
      _c("tr", [
        _c("td", [
          _vm._v(
            "基于合法利益所进行之资料处理，请求停止之权利\n                "
          ),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v(
              "Right to Object to Data Processing Based on Legitimate Interests "
            )
          ])
        ]),
        _c("td", [
          _vm._v(
            "\n                如我们处理您的个人资料系基于合法利益，您可以随时提出异议反对我们处理您的个人资料。这不会影响在提出异议前已经依照进行之资料处理之合法性。\n                "
          ),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v(
              "If we process your personal data based on legitimate interests, you have the right to object to our processing of your personal data at any time. This will not affect the lawfulness of processing based on legitimate interests before the objection is raised."
            )
          ])
        ])
      ]),
      _c("tr", [
        _c("td", [
          _vm._v("关闭Cookies之权利\n                "),
          _c("br"),
          _c("br"),
          _c("span", [_vm._v("Right to Disable Cookies ")])
        ]),
        _c("td", [
          _vm._v(
            "\n                您有权关闭Cookies。网页浏览器通常内建预设接受Cookies，但您可以简单透过更改您的浏览器设定来关闭。但请注意，如您选择关闭Cookies，可能使您无法充分使用我们的网站／应用程式。\n                "
          ),
          _c("br"),
          _c("br"),
          _c("span", [
            _vm._v(
              "\n                You have the right to disable cookies. Web browsers typically accept cookies by default, but you can easily disable them by adjusting your browser settings. However, please note that choosing to disable cookies may limit your ability to fully utilize our website/application. \n                "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "content_p" }, [
      _vm._v(
        "\n            若您对本隐私权保护政策有上述问题或不同意该等变更或修改，皆可利用本网站「问题回报」与我们联系或停止使用本网站服务。\n            "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n            客服信箱: "),
      _c("a", { attrs: { href: "mailto:damou-service@astrorg.com" } }, [
        _vm._v("damou-service@astrorg.com")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_p enVersion" }, [
      _vm._v(
        '\n            If you have any questions regarding this Privacy Policy or do not agree with such changes or modifications, you can utilize the "Report an Issue" feature on this website or directly contact us to cease using the website services. \n            '
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n            Customer Service Email: "),
      _c("a", { attrs: { href: "mailto:damou-service@astrorg.com" } }, [
        _vm._v("damou-service@astrorg.com")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "content_p" }, [
      _vm._v(
        "\n            根据 Facebook 政策，我们必须提供「Facebook\n            资料删除指示说明」，如果您想删除此平台上的 Facebook\n            登入应用数据，您可以按照以下步骤进行： \n            "
      ),
      _c("ol", [
        _c("li", [
          _vm._v("1.进入您的 Facebook 帐号的「设定和隐私」选单并点击「设定」")
        ]),
        _c("li", [_vm._v("2.向下滚动并点击「应用程式和网站」 ")]),
        _c("li", [_vm._v("3.找到并点击此应用程式")]),
        _c("li", [
          _vm._v("4.点击「移除」按钮，即成功地删除了您的应用程式活动。")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "content_p enVersion" }, [
      _vm._v(
        '\n            According to Facebook\'s policy, we are required to provide "Facebook Data Deletion Instructions."'
      ),
      _c("br"),
      _vm._v(
        "\n             If you wish to delete Facebook login app data on this platform, you can follow these steps: \n            "
      ),
      _c("ol", [
        _c("li", [
          _vm._v(
            '1.Go to the "Settings & Privacy" menu of your Facebook account and click on "Settings."'
          )
        ]),
        _c("li", [_vm._v('2.Scroll down and click on "Apps and Websites."  ')]),
        _c("li", [_vm._v("3.Find and click on this application. ")]),
        _c("li", [
          _vm._v(
            '4.Click the "Remove" button to successfully delete your app activity.'
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_title" }, [
      _vm._v("\n            [\n            "),
      _c("span", { staticClass: "title-space" }, [_vm._v("网站说明")]),
      _vm._v("]\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "content_p" }, [
      _c("li", [
        _vm._v(
          "\n              1.\n              本会员服务条款所称之「会员」，为依照本站所定之加入会员程序加入完成并通过认证者。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              2.\n              当您使用本站服务时，即表示您已阅读、了解并同意接受本服务条款的内容与规范，事项及相关法律之规定。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              3.\n              本站保留有审核加入会员资格之权利，另外已加入会员者，本站亦保留有解除其会员资格之权利。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              4.\n              本网站有权于任何时间修改或变更本服务条款之内容，建议您随时注意该等修改或变更。若您于任何修改或变更后继续使用本服务，视为您已阅读、了解并同意接受该等修改或变更。如果您不同意本服务条款的内容，或者您所属的国家或地域排除本服务条款内容之全部或一部时，您应立即停止使用本服务。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              5.\n              如手机载具之手机条码填写错误或统编输入错误，系统将自动转存至会员电子发票\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "content_p" }, [
      _c("li", [
        _vm._v(
          "\n              1.\n              使用本站所提供之会员服务时，于加入会员时所登录之帐号及密码使用之。\n              其登录资料请务必提供您本人正确、最新的资料，倘若基本资料有变更时，请不定期更新相关个人资料，确保其正确性。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              2.\n              会员须善尽帐号及密码的使用与管理之责任，并不得让与第三人使用。对于使用该会员之帐号及密码(无关于会员本身或其他人)利用本站服务所造成或衍生之所有行为及结果，会员须自行负担全部责任。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              3.\n              会员之帐号及密码遗失，或发现无故遭第三者盗用时，应立即通知本站连络挂失，因未即时通知，导致本站无法有效防止及修改时，所造成的所有损失，会员应自负全责。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              4.\n              盗用第三者会员之帐号及密码，导致第三者或本公司遭其他第三人或行政机关之调查或追诉时，第三者会员或本公司有权向您请求损害赔偿，包括但不限于诉讼费用、律师费及商誉损失等。\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "content_p" }, [
      _c("li", [
        _vm._v(
          "\n              1.\n              您承诺绝不为任何非法目的或以任何非法方式使用本服务，并承诺遵守中华民国相关法规及一切使用网际网路之国际惯例。您若系中华民国国籍以外之使用者，并同意遵守所属国家或地域之法令；对于使用者的一切行为，您须自行负担全部责任。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              2. 您于使用本站会员服务时应遵守以下限制： a)\n              侵害或毁损本网站或他人名誉、隐私权、营业秘密、商标权、著作权、专利权、其他智慧财产权及其他权利。\n              b) 使用违反公共秩序或善良风俗或其他不法之文字。 c)\n              强烈政治、宗教色彩的偏激言论。 d)\n              未经本公司许可，不得利用本服务或本网站所提供其他资源，包括但不限于图文资料库、编写制作网页之软体等，从事任何商业交易行为，或招揽广告商或赞助人。\n              e) 伪造讯息来源或以任何方式干扰传输来源之认定。\n              f)其他违反本站「会员服务条款」的内容。\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "content_p" }, [
      _c("li", [
        _vm._v(
          "\n              1.\n              本服务所载，或本服务所连结之一切软体或内容，或本公司之广告商或合伙人所提供之内容，均受其著作权或其他专有权利或法律所保障。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              2.\n              当您传输资料至本公司提供之服务时，您授权并许可本公司得以重制、修饰、改编或以其他形式使用该内容之全部或一部分，及利用该内容制作衍生著作。衍生著作之著作权悉归本公司所有。且承诺不非法转供其他直接营利目的或侵害您的权利之使用。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              3.\n              所有网页之页面出现之广告看板与活动讯息，所有权及经营权均为本公司所有，使用者除事先取得本公司同意外，不得自行使用所有讯息。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              4.\n              同时为提供行销、市场分析、统计或研究、或为提供会员个人化服务或加值服务之目的，会员同意本公司、或本公司之策略合作伙伴，得记录、保存、并利用会员在本网站所留存或产生之资料及记录，同时在不揭露各该资料之情形下得公开或使用统计资料。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              5.\n              本服务有时可能会出现中断或故障等现象，或许将造成您使用上的不便、资料丧失、错误、遭人篡改或其它经济上损失等情形。您于使用本服务时宜自行采取防护措施。本网站对于您因使用（或无法使用）本服务而造成的损害，不负任何赔偿责任。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              6.\n              对于您在本站中的所有言论、意见或行为仅代表您个人；不代表本公司的立场，本公司不负任何责任。本公司对于使用者所自称之身分，不担保其正确性。\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "content_p" }, [
      _c("li", [
        _vm._v(
          "\n              1.\n              凡因使用本服务所生之争执，均以台湾台北地方法院为第一审管辖法院。\n            "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n              2.\n              若因您使用本服务之任何行为，导致本公司遭第三人或行政机关之调查或追诉时，本公司有权向您请求损害赔偿，包括但不限于诉讼费用、律师费及商誉损失等。\n            "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }